import { Inputs } from '../../../../types/Enums';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';
import {
  InputComponentsConfigType,
  InputConfig,
} from '../../../../types/ConfigTypes';

/**
 * CONFIGS
 */
export const defaultConfig: InputConfig = {
  styling: {
    justifySelf: 'center',
    w: '100%',
  },
  config: {
    isTitleHidden: false,
  },
  gridConfig: {
    isFullScreen: false,
  },
};

const fullScreenConfig: InputConfig = {
  styling: {
    w: '100%',
    height: '100%',
    alignItems: 'center',
  },
  config: {
    isTitleHidden: true,
  },
  gridConfig: {
    isFullScreen: true,
  },
};

const iconSelectConfig: InputConfig = {
  styling: {
    maxW: 'md',
  },
  config: {
    isTitleHidden: false,
  },
  gridConfig: {
    isFullScreen: false,
  },
};

const titleHiddenConfig: InputConfig = {
  ...defaultConfig,
  config: {
    isTitleHidden: true,
  },
};

const singleCheckboxConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    [mq.mobileS]: {
      display: 'none',
    },
    [mq.laptop]: {
      display: 'block',
    },
  },
  config: {
    isTitleHidden: true,
  },
  gridConfig: {
    isContinueButtonHidden: true,
  },
};

export const fullWidthConfig: InputConfig = {
  ...defaultConfig,
  config: {
    isTitleHidden: true,
  },
  gridConfig: {
    isFullWidth: true,
  },
};

export const fullWidthWithTitleConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    gridColumn: { base: 'auto', tablet: 'span 2' },
  },
  gridConfig: {
    isFullWidth: true,
  },
};

const radioConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    gridColumn: { base: 'auto', tablet: 'span 2' },
  },
  config: {
    isTitleHidden: true,
  },
};

const radioSmallConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    my: 4,
    justifySelf: 'center',
    w: '100%',
  },
  config: {
    isTitleHidden: true,
  },
};

const addressConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    gridColumn: 'span 2',
  },
  config: {
    isTitleHidden: false,
  },
  gridConfig: {
    isFullScreen: true,
  },
};

const amountConfig: InputConfig = {
  ...defaultConfig,
  styling: {
    justifySelf: 'center',
    w: 'auto',
  },
  config: {
    isTitleHidden: true,
  },
  gridConfig: {
    isFullWidth: true,
  },
};

const linkConfig: InputConfig = {
  ...defaultConfig,
  config: {
    isTitleHidden: true,
    isActionIncluded: true,
  },
  gridConfig: {
    isFullWidth: true,
  },
};

/**
 * -----------------------------
 */

// This will give every InputType the defaultConfig
const allInputsDefaultConfig = Object.keys(Inputs).reduce(
  (obj, key) => ({ ...obj, [key]: defaultConfig }),
  {},
) as InputComponentsConfigType;

// Here you can specify a custom config for certain Input types
const InputComponentsConfig: InputComponentsConfigType = {
  ...allInputsDefaultConfig,
  [Inputs.ADDRESS]: addressConfig,
  [Inputs.ICON_SELECT]: iconSelectConfig,
  [Inputs.HOME]: fullScreenConfig,
  [Inputs.CHECKBOX]: titleHiddenConfig,
  [Inputs.SELECT_DETAILED]: fullWidthConfig,
  [Inputs.SLIDER]: fullWidthConfig,
  [Inputs.RADIO]: radioConfig,
  [Inputs.RADIO_SMALL]: radioSmallConfig,
  [Inputs.ROOM]: titleHiddenConfig,
  [Inputs.AMOUNT]: amountConfig,
  [Inputs.SINGLE_CHECKBOX]: singleCheckboxConfig,
  [Inputs.PIA_CLAIMS]: fullWidthConfig,
  [Inputs.ACCIDENT]: fullWidthConfig,
  [Inputs.ANNEXES]: fullWidthConfig,
  [Inputs.MULTISELECT]: defaultConfig,
  [Inputs.MULTISELECT_SIMPLE]: fullWidthConfig,
  [Inputs.MULTISELECT_DETAILED]: fullWidthConfig,
  [Inputs.COMPANY_SEARCH]: fullScreenConfig,
  [Inputs.CAR]: fullScreenConfig,
  [Inputs.LINK]: linkConfig,
  [Inputs.SECURITY_SYSTEM]: titleHiddenConfig,
  [Inputs.MULTILINE]: fullWidthWithTitleConfig,
  [Inputs.TABLE]: fullWidthConfig,
  [Inputs.NACE_CODE]: fullWidthWithTitleConfig,
  [Inputs.INDEX_SELECT]: fullWidthWithTitleConfig,
  [Inputs.NUMBER_PLATE]: titleHiddenConfig,
};

export default InputComponentsConfig;
